import { render, staticRenderFns } from "./empty.vue?vue&type=template&id=3d3237e4&scoped=true&"
import script from "./empty.vue?vue&type=script&lang=js&"
export * from "./empty.vue?vue&type=script&lang=js&"
import style0 from "./empty.vue?vue&type=style&index=0&id=3d3237e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3237e4",
  null
  
)

export default component.exports